
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/song_requests",
      function () {
        return require("private-next-pages/song_requests/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/song_requests"])
      });
    }
  